import { render } from "./ChatbotCreateOverlay.vue?vue&type=template&id=6128ceed&scoped=true&ts=true"
import script from "./ChatbotCreateOverlay.vue?vue&type=script&lang=ts"
export * from "./ChatbotCreateOverlay.vue?vue&type=script&lang=ts"

import "./ChatbotCreateOverlay.vue?vue&type=style&index=0&id=6128ceed&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6128ceed"]])

export default __exports__